import React from "react";

import '../../styles/page-line.css'
import { useSelector } from 'react-redux';
const PageLine = () => {
  const { isDark } = useSelector((state) => state.useReducer);
    return (
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='about-line' ><span style={{ backgroundColor: `${isDark ? "#3F51B5" : "#3F51B5"}` }}></span><span style={{ backgroundColor: `${isDark ? "#3F51B5" : "#3F51B5"}` }}></span><span style={{ backgroundColor: `${isDark ? "#3F51B5" : "#3F51B5"}` }}></span></div>
          </div>
        </div>
      </div>
    )
  }
export default PageLine
